import React, { Fragment } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import esLocale from 'date-fns/locale/es';
import { connect } from 'react-redux';
import { UTLabel, UTLoading } from '@widergy/energy-ui';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { arrayOf, bool, func, number, string, instanceOf } from 'prop-types';

import { referenceType } from 'types/turnsTypes';
import { message } from 'utils/stringUtils';

import CardError from '../CardError';

import DayReference from './components/DayReference';
import { DAY_REFERENCE_ARRAY } from './constants';
import styles from './styles.module.scss';

const Calendar = ({
  currentOffice,
  currentDay,
  officeAvailabilityDays,
  officeAvailabilityDaysLoading,
  officeAvailabilityDaysError,
  handleChangeMonth,
  handleSetDay,
  refCalendar,
  reload
}) => {
  const shouldDisableDate = _date => {
    const currentDate = new Date().getDate();
    const currentMonth = new Date().getMonth();
    if (isEmpty(officeAvailabilityDays) && _date.getMonth() !== currentMonth) return !(_date.getDate() === 1);
    const day = officeAvailabilityDays.find(item => item.day === _date.getDate());
    return _date.getMonth() === currentMonth && _date.getDate() === currentDate
      ? false
      : !day || !day.available_turns;
  };

  const DayReferenceRender = day => <DayReference day={day} />;
  return (
    <div className={`${styles.calendarContainer} ${!currentOffice && styles.hidden}`}>
      <span className={styles.anchor} ref={refCalendar} />
      <UTLabel semibold large className={styles.title}>
        {message('Turns:selectDate')}
      </UTLabel>
      <UTLoading loading={officeAvailabilityDaysLoading} className={styles.loading}>
        {currentDay && (
          <Fragment>
            <UTLabel className={styles.labelReference}>{message('Commons:reference')}:</UTLabel>
            <div className={styles.containerDayReference}>
              <div className={styles.containerDays}>{DAY_REFERENCE_ARRAY.map(DayReferenceRender)}</div>
              <UTLabel secondary className={styles.labelWarning}>
                {message('Turns:calendarWarning')}
              </UTLabel>
            </div>
            <UTLabel secondary className={styles.labelInfo}>
              {message('Turns:calendarInfo')}
            </UTLabel>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
              <DatePicker
                disableToolbar
                onMonthChange={handleChangeMonth}
                shouldDisableDate={shouldDisableDate}
                variant="static"
                disablePast
                value={currentDay}
                onChange={handleSetDay}
              />
            </MuiPickersUtilsProvider>
          </Fragment>
        )}
        {officeAvailabilityDaysError && (
          <CardError error={officeAvailabilityDaysError} buttonFunction={reload} />
        )}
      </UTLoading>
    </div>
  );
};

Calendar.propTypes = {
  currentOffice: number,
  currentDay: instanceOf(Date),
  officeAvailabilityDays: arrayOf(instanceOf(Date)),
  officeAvailabilityDaysLoading: bool,
  officeAvailabilityDaysError: string,
  handleChangeMonth: func.isRequired,
  handleSetDay: func,
  reload: func,
  refCalendar: referenceType
};

const mapStateToProps = store => ({
  officeAvailabilityDays: store.utility.officeAvailabilityDays,
  officeAvailabilityDaysLoading: store.utility.officeAvailabilityDaysLoading,
  officeAvailabilityDaysError: store.utility.officeAvailabilityDaysError
});

export default connect(mapStateToProps)(Calendar);
